/**
 * usePersistedListingPreferences — effect that mirrors live UI state into
 * the page's savePreferences callback.
 *
 * A3 from listing-abstraction-opportunities.md
 *
 * Extracts the repetitive useEffect(savePreferences(...), [...]) pattern
 * shared by every preference-backed listing. Search is intentionally NOT
 * accepted (never persisted — contract rule).
 */
import { useEffect } from 'react';
export function usePersistedListingPreferences({ savePreferences, pageSize, sort, filters, activeFilterKeys, visibleColumnKeys }) {
    useEffect(() => {
        savePreferences({ pageSize, sort, filters, activeFilterKeys, visibleColumnKeys });
    }, [savePreferences, pageSize, sort, filters, activeFilterKeys, visibleColumnKeys]);
}
